import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton, SpecraText } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { mentionsAsText } from '../../lib/chat/mentions';
/**
 * Suggested first questions under the new-chat composer. Picking one fills
 * the composer (it is not sent), so the user sees what it asks and can edit
 * it first.
 */ export function StarterPrompts({ starters, onPick }) {
    if (starters.length === 0) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-2",
        "data-testid": Testids.assistant.starterPrompts,
        children: [
            /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "meta",
                tone: "muted",
                children: "Try asking"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex flex-wrap gap-2",
                children: starters.map((s)=>/*#__PURE__*/ _jsx(SpecraButton, {
                        size: "sm",
                        variant: "secondary",
                        className: "h-auto whitespace-normal py-1.5 text-left font-normal",
                        "data-testid": Testids.assistant.starterPrompt,
                        "data-starter": s.id,
                        onClick: ()=>onPick(s.prompt),
                        children: mentionsAsText(s.prompt)
                    }, s.id))
            })
        ]
    });
}
